import Rete from "rete";
import { StockDataSocket } from "../../rete-controls/StockDataListControl.js";
import { StockChartControl } from "../../rete-controls/StockChartControl.js";
import AnyTypeSocket from "../../../Utils/CommonSockets.js";
import { EventBus } from "../../../event-bus.js";
import { NumberSocket } from "../../rete-controls/NumberControl.js";
export default class StockChartComponent extends Rete.Component {
  constructor() {
    super("CandleStick Chart"); // name
    this._categories = ["Visualization", "tryMe"];
    this._nodeStateData = {};
    this._eventRegistered = false;
    EventBus.$on('global-reset-nodes', x => {
      this.doResetNode("all");
  });

  }
  doResetNode(node) {

  }
  builder(node) {
    let inp1 = new Rete.Input("in1", "Stock Data", AnyTypeSocket);
    let inp2 = new Rete.Input("in2", "Annotations", AnyTypeSocket);
    let inp3 = new Rete.Input("in3", "Price", NumberSocket,true);
    let chartControl = new StockChartControl(this.editor, "chart");
this.registerOnRemove();
    return node
      .addInput(inp1)
      .addInput(inp2)
      .addInput(inp3)
      .addControl(chartControl);
  }
  registerOnRemove() {
    if (!this._eventRegistered) {

      this.editor.on("connectionremoved", connection => {
        try{
        this.clearAnnotation(connection.input.node);
        }catch(ex){}
      });
    }
    this._eventRegistered = true;
  }
  convertStockDataToChartData(stock) {
    return {
      x: stock.date,
      y: [stock.open, stock.high, stock.low, stock.close]
    };
  }
  convertStockDataToChartDatas(stockData) {
    let chartData = [];
    for (let stock of stockData) {
      let d = this.convertStockDataToChartData(stock);
      chartData.push(d);
    }

    return [{ data: chartData }];
  }

  updateChart(node, stockData) {
    this.editor.nodes
      .find(n => n.id == node.id)
      .controls.get("chart")
      .setValue(this.convertStockDataToChartDatas(stockData));
  }

  updateAnnotation(node, stockData) {
    this.editor.nodes
      .find(n => n.id == node.id)
      .controls.get("chart")
      .addAnnotation(this.convertStockDataToChartDatas(stockData));
  }

  hasAnnotation(node, stockData) {
    return this.editor.nodes
      .find(n => n.id == node.id)
      .controls.get("chart")
      .hasAnnotation(this.convertStockDataToChartDatas(stockData));
  }

  updateYAnnotation(node,key, numberIn) {
    this.editor.nodes
      .find(n => n.id == node.id)
      .controls.get("chart")
      .addYAnnotation(key,numberIn);
  }

  hasYAnnotation(node, key, numberIn) {
    return this.editor.nodes
      .find(n => n.id == node.id)
      .controls.get("chart")
      .hasYAnnotation(key,numberIn);
  }

  clearAnnotation(node) {
    this.editor.nodes
      .find(n => n.id == node.id)
      .controls.get("chart")
      .clearAnnotation();
  }

  figureOutDataType(inp) {
    if (!(inp instanceof Array)) {
      if (inp instanceof Object) {
        if (typeof inp.isStockData === "function") {
          return inp.data;
        }
      }
    } else if (inp.length !== 0 && this.isStockElement(inp[0])) {
      return inp;
    } else if(inp.length !== 0 ){
      return "array";
    }else{
      return null;
    }
  }
  isStockElement(el) {
    return el.date !== undefined && el.open !== undefined;
  }
  worker(node, inputs, outputs) {
    let in1 = inputs["in1"];
    let in2 = inputs["in2"];
    if (in2.length !== 0 && in2[0].length === 0 ) {
      this.clearAnnotation(node);
    }
    if (in1.length !== 0) {
      in1 = in1[0];
      let d1 = this.figureOutDataType(in1);
      if (d1 !== null) this.updateChart(node, d1);

      if (in2.length !== 0) {
        in2 = in2[0];

        let d2 = this.figureOutDataType(in2);
        if (d2 == "array") {
          d2 = null;
          if (in2[0].length  !== 0 && this.isStockElement(in2[0][0])) {
            for (var dd in in2) {
              let d3 = this.figureOutDataType(in2[dd]);
              if (d3 !== "array" && !this.hasAnnotation(node,d3)) this.updateAnnotation(node, d3);
            }
          }
        } else {
          if (d2 !== null && !this.hasAnnotation(node,d2)) this.updateAnnotation(node, d2);
        }
      }

      let index = 0;
        for(let connection in node.inputs.in3.connections){
            let nodeId = node.inputs.in3.connections[connection].node;
            let nodeOutput =  node.inputs.in3.connections[connection].output;
            let nodeName = this.editor.nodes.find(n => n.id == nodeId).name;
            let nodeNode = this.editor.nodes.find(n => n.id == nodeId);
            let outputName = nodeNode.outputs.get(nodeOutput).name

            let key =  `${nodeName}_${nodeId}_${outputName}` ;
            let value = inputs['in3'][index++] 
           if(!this.hasYAnnotation(node, key,value)){
            this.updateYAnnotation(node,key,value);
           }

        }
    } 
    else {
      this.clearAnnotation(node);
      this.editor.nodes
        .find(n => n.id == node.id)
        .controls.get("chart")
        .setValue([
          {
            data: [
              {
                x: new Date(),
                y: [100, 105, 99, 1914]
              }
            ]
          }
        ]);
    }
  }
}

//ReteComponentStore.add(new NumberAdderComponent());
